import { createContext } from 'react';

export type Context = {
  repositories: BB.Repository[];
  loadRepositories: (includeStatus: boolean) => Promise<BB.Repository[]>;
};

const ReposContext = createContext<Context>({
  repositories: [],
  loadRepositories: (_includeStatus: boolean) => Promise.resolve([]),
});

ReposContext.displayName = 'ReposContext';

// eslint-disable-next-line import/no-default-export
export default ReposContext;
